import { FC, memo, useEffect, useState } from 'react'
import { Accordion, AccordionButton, AccordionItem, AccordionPanel, Fade, Flex, Text } from '@chakra-ui/react'

import { Pencil } from 'components/icons'

type Props = {
  content: JSX.Element
  contentWhenAccordionIsClose?: JSX.Element
  title: string
  description?: string
  shouldOpen?: boolean
}

const FilterGroupHeader: FC<Props> = ({ content, contentWhenAccordionIsClose, title, description, shouldOpen = false }) => {
  const [defaultIndex, setDefaultIndex] = useState(shouldOpen ? [0] : [1])

  function changeDefaultIndex() {
    setDefaultIndex(defaultIndex[0] === 1 ? [0] : [1])
  }

  useEffect(() => {
    if (!shouldOpen) setDefaultIndex([])
  }, [shouldOpen])

  return (
    <Accordion index={defaultIndex} allowMultiple>
      <AccordionItem bg="light" border="none" borderBottom="2px solid" borderColor="borderColor">
        {({ isExpanded }) => (
          <>
            <AccordionButton
              p={4}
              border="none"
              _hover={{ '.filter-groups': { color: 'primary' }, '.pencil': { color: 'primary' } }}
              onClick={changeDefaultIndex}
            >
              <Flex width="100%" direction="column">
                <Flex direction="column" textAlign="left" gap={1}>
                  <Flex className="filter-groups" align="center" gap={2}>
                    <Text fontSize="md" className="accessible">
                      {title}
                    </Text>
                    <Pencil className="accessible pencil" color={isExpanded ? 'dark' : 'transparent'} boxSize={5} />
                  </Flex>
                  {description && <Text variant="secondary">{description}</Text>}
                </Flex>

                {!isExpanded && <Fade in={!isExpanded}>{contentWhenAccordionIsClose}</Fade>}
              </Flex>
            </AccordionButton>

            <AccordionPanel pb={4}>{isExpanded && content}</AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  )
}

export default memo(FilterGroupHeader)
